export default __webpack_public_path__ + "static/media/work-5.d903ba45.jpg";